







import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Zoomable extends Vue {
    base: number = 2100;
    width: number = 0;
    height: number = 0;

    get frameStyle() {
        const scale = this.width / this.base;
        return {
            'width': `${this.base}px`,
            'min-width': `${this.base}px`,
            'max-width': `${this.base}px`,
            'transform': `scale(${scale})`,
            'height': `${this.height / scale}px`,
        };
    }

    handleResize() {
        this.width = window.innerWidth;
        this.height = window.innerHeight;
    }

    handleKey(event: any) {
        // if (event.key === 'ArrowUp') {
        //     this.base += 50;
        // } else if (event.key === 'ArrowDown') {
        //     this.base -= 50;
        // }
        // console.log('base width:', this.base);
    }

    created() {
        window.addEventListener('keyup', this.handleKey);
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    }
}
